import Layout from '@/layout'

const businessAreaRouter = {
  path: '/business_area',
  component: Layout,
  redirect: '/business_area/business_area_diagram',
  // name: 'Nested',
  meta: {
    title: 'Khu kinh doanh'
  },
  children: [
    {
      path: '/business_area/breakfast',
      component: () => import('@/views/mci/businessArea/breakfastReal.vue'),
      name: '',
      meta: { title: 'Bữa sáng' }
    }
  ]
}

export default businessAreaRouter
